import { createAsyncAction, createAction } from 'redux-promise-middleware-actions';
import { addAsyncActionPostfixes } from '../utils/actionTypeCreator';
// eslint-disable-next-line import/no-cycle
import { tneAxiosClient } from '../api/apiSettings';
import { generalEnums } from '../utils/enums';

export const types = {
  ...addAsyncActionPostfixes({
    GET_GLOBAL_NOTIFICATION: 'GET_GLOBAL_NOTIFICATION',
    UPDATE_NOTIFICATION_STATUS: 'UPDATE_NOTIFICATION_STATUS'
  }),
  SET_NOTIFICATION: 'SET_NOTIFICATION',
  REMOVE_NOTIFICATION: 'REMOVE_NOTIFICATION',
  SHOULD_UPDATE_TIMESHEETS_NOTIFICATION_READ: 'SHOULD_UPDATE_TIMESHEETS_NOTIFICATION_READ',
  SHOULD_UPDATE_EXPENSES_NOTIFICATION_READ: 'SHOULD_UPDATE_EXPENSES_NOTIFICATION_READ',
  MARK_TIMESHEET_NOTIFICATIONS_READ: 'MARK_TIMESHEET_NOTIFICATIONS_READ',
  MARK_EXPENSE_NOTIFICATIONS_READ: 'MARK_EXPENSE_NOTIFICATIONS_READ'
};

export const setNotification = createAction(types.SET_NOTIFICATION, (message) => message);

export const removeNotification = createAction(types.REMOVE_NOTIFICATION);

export const getGlobalNotification = createAsyncAction(types.GET_GLOBAL_NOTIFICATION, () => {
  return tneAxiosClient.get(`v1/get-notification`).then((res) => res.data);
});

export const updateNotificationStatus = createAsyncAction(types.UPDATE_NOTIFICATION_STATUS, (Id, type) => {
  return tneAxiosClient
    .put(`v1/mark-notification-read?id=${Id}&type=${type}`)
    .then((res) => ({ ...res.data, Id, type: type === 'tne' ? 'TnEnotification' : 'JobMatchNotification' }));
});

export const shouldReadTimesheetsNotification = createAction(
  types.SHOULD_UPDATE_TIMESHEETS_NOTIFICATION_READ,
  ({ enabled, status }) => ({ enabled, status })
);
export const shouldReadExpensesNotification = createAction(
  types.SHOULD_UPDATE_EXPENSES_NOTIFICATION_READ,
  ({ enabled, status }) => ({ enabled, status })
);

export const markTimesheetNotificationsRead = createAsyncAction(
  types.MARK_TIMESHEET_NOTIFICATIONS_READ,
  (id, tneStatus) => {
    return tneAxiosClient
      .put(`v1/mark-tne-contractor-visited?id=${id}&type=${generalEnums.TIMESHEET}&tneStatus=${tneStatus}`)
      .then((res) => res.data);
  }
);

export const markExpenseNotificationsRead = createAsyncAction(
  types.MARK_EXPENSE_NOTIFICATIONS_READ,
  (id, tneStatus) => {
    return tneAxiosClient
      .put(`v1/mark-tne-contractor-visited?id=${id}&type=${generalEnums.EXPENSE}&tneStatus=${tneStatus}`)
      .then((res) => res.data);
  }
);
